import { AuthLayout } from '@/components/auth/AuthLayout'
import { Button } from '@/components/ui/button'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { useNavigate } from 'react-router-dom'

export default function UnauthorizedPage() {
  useDocumentTitle('Access denied')
  const navigate = useNavigate()

  return (
    <AuthLayout showTestimonial={false}>
      <div className="w-full text-foreground">
        <div className="mb-6 flex items-center justify-center">
          <div className="rounded-full bg-destructive/10 p-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-6 w-6 text-destructive"
            >
              <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path>
              <path d="m15 9-6 6"></path>
              <path d="m9 9 6 6"></path>
            </svg>
          </div>
        </div>

        <div className="mb-6 text-center">
          <h1 className="mb-2 text-center text-4xl font-light tracking-tight text-foreground">
            Access denied
          </h1>
          <p className="mx-auto mb-6 max-w-md text-sm text-muted-foreground">
            You don&apos;t have permission to access this page
          </p>
        </div>

        <div className="mx-auto flex max-w-xs flex-col gap-4">
          <Button onClick={() => navigate('/today')} className="w-full">
            Go home
          </Button>

          <Button
            type="button"
            variant="outline"
            onClick={() => navigate('/')}
            className="w-full"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="mr-1.5 inline h-4 w-4"
            >
              <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            Choose an organization
          </Button>

          <Button
            onClick={() => navigate('/login')}
            variant="link"
            className="text-primary"
          >
            Back to sign in
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="ml-2 inline h-4 w-4"
            >
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </Button>
        </div>
      </div>
    </AuthLayout>
  )
}
